import React from 'react';
import axios from 'axios';
import * as query from './queryurl';
import { toast } from './components/Notifier';

const catchError = error => {
  // console.log(error);
  toast('Server could not be reached, check network connectivity', {
    status: 'error'
  });
  return { status: 'error' };
};

const getSearchParams = data => {
  const searchParams = Object.keys(data)
    .map(key => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
    })
    .join('&');

  // create new URLSearchParams from the formated searchParams
  const params = new URLSearchParams(searchParams);
  return params;
};

const postToApi = path => (data, jsonFormat = false) => {
  let params = null;

  let auth = localStorage.getItem('uniabuja-login-token');
  auth = auth.slice(1, auth.length - 1);

  if (jsonFormat) {
    params = JSON.stringify(data);
  } else {
    params = getSearchParams(data);
  }

  const options = {
    method: 'POST',
    body: params,
    headers: {
      Authorization: `Bearer ${auth}`
    }
  };

  return FETCH.request(path, options);
};

const postFile = path => data => {
  let auth = localStorage.getItem('uniabuja-login-token');
  auth = auth.slice(1, auth.length - 1);

  const options = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${auth}`,
      'Content-Type': 'multipart/form-data'
    }
  };

  return axios
    .post(`${query.BaseURI}/${path}`, data, options)
    .then(response => {
      if (response.status === 'error' && response.error_code === 'E01') {
        localStorage.removeItem('uniabuja-login-token');
        localStorage.removeItem('uniabuja-login-data');
        window.location.reload();
      } else {
        return response.data;
      }
    })
    .catch(catchError);
};

const postToApiWithoutAuth = path => data => {
  const params = getSearchParams(data);
  const options = {
    method: 'POST',
    body: params
  };

  return FETCH.request(path, options);
};

const getFromApi = path1 => path2 => {
  let auth = localStorage.getItem('uniabuja-login-token');
  auth = auth.slice(1, auth.length - 1);
  const options = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${auth}`
    }
  };

  if (path2) return FETCH.request(`${path1}/${path2}`, options);
  return FETCH.request(path1, options);
};

const deleteFromApi = path1 => path2 => {
  let auth = localStorage.getItem('uniabuja-login-token');
  auth = auth.slice(1, auth.length - 1);
  const options = {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${auth}`
    }
  };
  if (path2) return FETCH.request(`${path1}/${path2}`, options);
  return FETCH.request(path1, options);
}

class FETCH extends React.Component {
  constructor() {
    super();
    this.baseuri = query.BaseURI;
    this.options = {
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
        'Access-Control-Allow-Origin': '*'
      }
    };
  }

  static request(url, init = {}) {
    // overwrite the init options method
    // from init object specific to the request type
    const param = Object.assign({}, this.options, init);

    return fetch(`${query.BaseURI}/${url}`, param)
      .then(response => {
        return response.json();
      })
      .then(response => {
        if (response.status === 'error' && response.error_code === 'E01') {
          localStorage.removeItem('uniabuja-login-token');
          localStorage.removeItem('uniabuja-login-data');
          window.location.reload();
        } else {
          return response;
        }
      })
      .catch(catchError);
  }

  static login = postToApiWithoutAuth(query.LoginUrl);

  static resetPassword = postToApiWithoutAuth(query.ResetPassword);

  static getDocuments = getFromApi(query.Documents);

  // get student's latest transaction
  static getLatestTransaction = getFromApi(query.LatestTransction);

  static getTransactionHistory = getFromApi(query.transactionHistory);

  static getTransactionDetails = getFromApi(query.transctionDetails);

  static getFees = getFromApi(query.Fees);

  static getProfile = getFromApi(query.Profile);

  static getCourseConfig = getFromApi(query.CourseConfig);

  static getFeeDetails = getFromApi(query.FeeDetails);

  static GetCourses = getFromApi(query.Courses);

  static UpdateFee = postToApi(query.UpdateFee);

  static UpdateProfile = postToApi(query.Profile);

  static ChangePassword = postToApi(query.ChangePassword);

  static requeryPayment = getFromApi(query.PaymentStatus);

  static getAccmodations = getFromApi(query.Accommodation);

  static getAccmodationDetails = getFromApi(query.AccommodationDetails);

  static bookAccommodation = postToApi(query.BookAccommodation);

  static getBooking = getFromApi(query.AccommodationBooking);

  static UpdateAccommodationRef = postToApi(query.UpdateAccomodationRef);

  static BookWithCoupon = postToApi(query.BookWithCoupon);

  static RegisterCourses = postToApi(query.RegisterCourses);

  static RegisteredCourses = getFromApi(query.RegisteredCourses);

  static getCourseDetails = getFromApi(query.CourseDetails);

  static PassportUpload = postFile(query.PassportUpload);

  static getFirstSemesterExtraCourses = getFromApi(
    query.FirstSemesterExtraCourses
  );

  static getSecondSemesterExtraCourses = getFromApi(
    query.SecondSemesterExtraCourses
  );

  static deleteCourse = deleteFromApi(query.DeleteCourse);
}

export default FETCH;
